/***********************************************************************************************************************
 *
 *  Функции для модуля LUI (LoCode UI)
 *
 ***********************************************************************************************************************/


/**
 *  Создает className из массива
 *  @param {?string[]} classNames
 */
export function luiClassName( classNames ){
    return classNames.filter( item => (item??'')!=='' ).join(' ')
}


/**
 *  Проверка допустимых значений
 *  Если значений нет в allowedValues вывод предупржедение
 *
 *```JS
 *  // Значения
 *  let values = {
 *      key: {value}
 *  }
 *  // Пример allowedValues
 *  const allowedValues = {
 *      key:  [ value1, value2, value3 ],
 *  }
 *```
 *  @param {{}} allowed - объект допустимых значений. Вида { ключ: массив значений,... }
 *  @param {{}} values - объект значений. Вида { ключ: значение,... }
 *  @param {string} component - Имя компонента в сообщении
 */
export function luiCheckAllowedValues( { values, allowed, component }){
    for (const name of Object.keys(allowed) ){
        const value = values[name]
        if( value && !allowed[name].includes(value) ){
            console.warn(`${component} Bad ${name}: ${value}, allowed: ${allowed[name]}`)
        }
    }
}


/**
 *  Выдает Уникальный ключ для списков и т.п.
 *  @param {*} obj — если задан объект, то ключ будет на основе его строкового отображения
 *  @returns {string}
 */
export function luiUniKey(obj=undefined){
    return obj!==undefined
        ? luiHash(JSON.stringify(obj))
        : Date.now().toString(32) +'.'+ Math.random().toString(32).substring(2)
}


/**
 *  Функция для создания короткого хэша из строки
 *  @param {string} str - Входная строка
 *  @returns {string} - Короткий хэш
 */
export function luiHash(str){
    let hash = 0
    const prime = 31
    for (let i = 0; i < str.length; i++){
        hash = (hash * prime + str.charCodeAt(i)) & 0xFFFFFFFF;
    }
    return hash.toString(16)
}


/**
 *  Функция обновляет параметры объекта `obj` на основе объекта `params`
 *
 *  @param {{}} obj
 *  @param {{}} params
 *  @param {?[]} keys Ключи, если не заданы берутся из obj
 *  @returns {*}
 */
export function luiUpdateParams(obj, params={}, keys=null ){
    keys = keys??Object.keys(obj)
    for (const key of keys){
        if(params[key]!==undefined) obj[key] = params[key]
    }
    return obj
}


/**
 *  Формат даты
 *
 *  Паттерн:
 *  - YYYY(YY) — Года
 *  - MM(M) — Месяцы
 *  - DD(D) — Дни
 *  - hh(h) — Часы
 *  - mm(m) — минуты
 *  - ss(s) — секунды
 *
 *  @param {*} date - будет преобразовано в Date
 *  @param {string} pattern - Паттерн, пример: YYYY-MM-DD
 *  @returns {null|string}
 */
export function luiDateFormat(date, pattern){
    const d = new Date(date)
    return isNaN(d.getDate())
        ? null
        : pattern
            .replaceAll( 'YYYY', String(d.getFullYear()) )
            .replaceAll( 'YY',  String(d.getFullYear()).substring(2,4) )
            .replaceAll( 'MM',  String(d.getMonth()+1).padStart(2, '0') )
            .replaceAll( 'M',   String(d.getMonth()+1) )
            .replaceAll( 'DD',  String(d.getDate()).padStart(2, '0') )
            .replaceAll( 'D',   String(d.getDate()) )
            .replaceAll( 'hh',  String(d.getHours()).padStart(2, '0') )
            .replaceAll( 'h',   String(d.getHours()) )
            .replaceAll( 'mm',  String(d.getMinutes()).padStart(2, '0') )
            .replaceAll( 'm',   String(d.getMinutes()) )
            .replaceAll( 'ss',  String(d.getSeconds()).padStart(2, '0') )
            .replaceAll( 's',   String(d.getSeconds()) )
}


/**
 *  Получение ширины scrollbar Окна
 *  @returns {number}
 */
export function luiGetScrollbarWidth(ifExists = true){

    const hasScrollbar = document.body.scrollHeight > window.innerHeight

    if(ifExists && !hasScrollbar) return 0;

    // Creating invisible container
    const outer = document.createElement('div')
    outer.style.visibility = 'hidden'
    outer.style.overflow = 'scroll' // forcing scrollbar to appear
    outer.style.msOverflowStyle = 'scrollbar' // needed for WinJS apps
    document.body.appendChild(outer)

    // Creating inner element and placing it in the container
    const inner = document.createElement('div')
    outer.appendChild(inner)

    // Calculating difference between container's full width and the child width
    const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth)

    // Removing temporary elements from the DOM
    outer.parentNode.removeChild(outer)

    return scrollbarWidth
}
